(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireaf93"];
var parcelRegister = parcelRequire.register;
parcelRegister("i0Ulh", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d1d3ee73afe85d0d$export$b3890eb0ae9dca99; });
function $d1d3ee73afe85d0d$export$b3890eb0ae9dca99() {
    /* Define close bio function */ var closeBio = function(openCard) {
        if (!openCard) return;
        /* Remove the bio-visible class from the card */ openCard.classList.remove("bio-visible");
        /* Toggle the aria-hidden attribute on the bio */ var bio = openCard.querySelector(".bio");
        bio.setAttribute("aria-hidden", "true");
    };
    /* Define toggle bio function */ var toggleBio = function(card) {
        if (!card) return;
        /* Toggle the bio-visible class to the card */ card.classList.toggle("bio-visible");
        /* Toggle the aria-hidden attribute on the bio */ var bio = card.querySelector(".bio");
        if (bio) {
            var ariaHidden = bio.getAttribute("aria-hidden");
            if (ariaHidden === "true") bio.setAttribute("aria-hidden", "false");
            else bio.setAttribute("aria-hidden", "true");
        }
    };
    /* Find all people cards */ var peopleCards = document.querySelectorAll(".card-person");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var peopleCard = _step.value;
            peopleCard.addEventListener("click", function() {
                // Check if the card is already open and close it if it is
                if (peopleCard.classList.contains("bio-visible")) {
                    closeBio(peopleCard);
                    return;
                }
                /* Close any open cards */ var openCards = document.querySelectorAll(".bio-visible");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openCards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var openCard = _step.value;
                        closeBio(openCard);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                /* Toggle the bio-visible class on the card */ toggleBio(peopleCard);
            });
        };
        /* Loop through each card and add event listeners */ for(var _iterator = peopleCards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});

})();
//# sourceMappingURL=people-cards.df7252a6.js.map
